import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

import { SliderBackground } from './types';

const backgroundMap = {
  blue: 'linear-gradient(134.48deg, rgba(90, 0, 238, 0) -10.28%, #42449C 108.7%)',
};

export default createUseStyles<string, { backgroundColor: SliderBackground }>(
  ({ breakpoints }: ITheme) => ({
    root: {
      background: ({ backgroundColor }) => backgroundMap[backgroundColor] || 'none',
      borderRadius: 32,
      marginInline: 'auto',
      maxWidth: 1360,

      [mediaQuery(breakpoints.largeDesktop)]: {
        marginInline: 24,
      },
    },
    rootSingle: {
      paddingBlock: 40,
      paddingInline: 112,
      marginBottom: 40,

      [mediaQuery(breakpoints.tablet)]: {
        paddingInline: 16,
        paddingBottom: 32,
      },
    },
  }),
  {
    name: 'BulletSlider',
  },
);
